import React, { useEffect, useRef, useState } from "react";

import ListUI from "./DesignElements/ListUI";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog,
  BotMessageSquare,
  Dices,
  CopyPlus,
  CornerUpLeftIcon,
  CornerUpRight,
  Trash2,
  CornerRightUp,
  CornerLeftDown,
  Pencil,
  ChartBar,
  CheckIcon,
  CheckCheck} from 'lucide-react';
import PlatformKeyFeaturesCard1 from "./Cards/KeyFeatures/PlatformKeyFeatures/PlatformKeyFeaturesCard1";
import PlayerPageCard1 from "./Cards/KeyFeatures/PlayerPageCards/PlayerPageCard1";
import PlatformKeyFeaturesCardIndexPage from "./Cards/KeyFeatures/PlatformKeyFeatures/PlatformKeyFeaturesCardIndex";
import Theme1CardsIndexPage from "./Templates/Template1/Theme1CardsIndex";

const UIWebBlockRenderer = ({setCurrentContentIndex,setHideReduUnDo, moveItemUp,moveItemDown,deleteItem,duplicateItem,duplicateContentsItem,currentIndex,item ,dynamicId,setCurrentObject,
}) => {  
    
 const [isHovered, setIsHovered] = useState(false);
     const dispatch = useDispatch();
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
    const [reloadItems, setReloadItems] = useState(true);

    useEffect(()=>{
        setReloadItems(false); setReloadItems(true)
    },[ currentIndex]
)
    const extractElementType = (str) => {
  const match = str?.match(/^.*?-(.*?)-.*$/);
  return match ? match[1] : null;
};

const scrollToSection = () => {
  setTimeout(() => {
    const scrollerBox = document.querySelector(".browserFrameScroller");
    if (!scrollerBox) return;

    const section = scrollerBox.querySelector("#cardID" + dynamicId);
    if (!section) return;

    // distance from section top to container top in viewport coordinates
    const sectionTop = 0;
    const containerTop = 0; 

    // convert that difference into container.scrollTop space
    const offsetInContainer = sectionTop - containerTop + scrollerBox?.scrollTop;

    // apply any padding you want (e.g. leave 20px from top)
    const padding = 0; // change to 20 if you want space from top
    const targetScrollTop = offsetInContainer - padding-20;

    scrollerBox?.scrollTo({ top: targetScrollTop?targetScrollTop:0, behavior: "smooth" });
  }, 100);
};
const scrollToSectionDown = () => {
  setTimeout(() => {
    const scrollerBox = document.querySelector(".browserFrameScroller");
    if (!scrollerBox) return;

    const section = scrollerBox.querySelector("#cardID" + dynamicId);
    if (!section) return;

    // Get the height of the target div
    const divHeight = section?.offsetHeight+50;

    // Scroll down by that height
    scrollerBox?.scrollBy({
      top: divHeight?divHeight:0,
      behavior: "smooth",
    });
  }, 100);
};

  return (
  <div id={"cardID"+dynamicId} className={isHovered?"hoverItemElement" :"" }> 
  <div  className={"hoverItemElementOuter"} style={{border:isHovered?dynamicId==item?.myKey?"2px solid rgba(144, 202, 249,1)":"2px solid transparent":"",borderRadius:"5px"}}>
     {isHovered? <div className={"showPlusElementOuter" } > <div className="showPlusElement"  onMouseEnter={
                        ()=>handleMouseEnter("","","")}
        onMouseLeave={handleMouseLeave} style={{}}><div style={{ position:"absolute",padding:"5px",marginTop:"-19px",width:"25px",height:"25px",borderRadius:"50%",background:"rgba(144, 202, 249,0.41)"}} ><Plus size={23} style={{width:"25px",height:"25px",borderRadius:"50%",background:"rgba(144, 202, 249,0.941)"}} color="#ffffff" /></div></div></div>
   :""}
    {
      <div style={{transform:"scale(1.1)"}}> 
        <div  onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}  style={{height:"40px",width:"100%",position:"absolute",top:"-25px",left:"0px",margin:"10px"}}>
      
    </div>
        
         {isHovered? <> 
      <div  onMouseEnter={() => setIsHovered(true)}
       className="showElementSettings" style={{right:"220px"}}> 
        <div style={{position:"relative",top:"1px",left:"0px",width:"27px",right:"0px",bottom:"0px"}}> 
        <div className="ElementSettingsItem" style={{position:"relative",left:"-1px"}} onMouseEnter={
                        ()=>handleMouseEnter("rgba(144, 202, 249,1) "," #ffffff","Move Up")}
        onMouseLeave={handleMouseLeave}
        
        onClick={()=>{moveItemUp(item);scrollToSection()}}
        >
      <CornerRightUp size={18}  color="#444" />
      </div> </div>   <div style={{position:"relative",top:"1px",left:"0px",width:"27px",right:"0px",bottom:"0px"}}> 
        <div className="ElementSettingsItem"style={{position:"relative",left:"-1px"}} onMouseEnter={
                        ()=>handleMouseEnter("rgba(144, 202, 249,1) "," #ffffff","Move Down")}
        onMouseLeave={handleMouseLeave}
        
          onClick={()=>{moveItemDown(item);setTimeout(()=>{scrollToSection()},500)}}>
      <CornerLeftDown size={18}  color="#444" />
      </div> </div>  <div style={{position:"relative",top:"1px",left:"0px",width:"27px",right:"0px",bottom:"0px"}}> 
        <div className="ElementSettingsItem" style={{position:"relative",left:"-1px"}} onMouseEnter={
                        ()=>handleMouseEnter("rgba(144, 202, 249,1) "," #ffffff","Duplicate element")}
        onMouseLeave={handleMouseLeave}
         onClick={()=>{duplicateItem(item);scrollToSectionDown()}}>
      <CopyPlus size={18}  color="#444" />
      </div></div>  <div style={{position:"relative",top:"1px",left:"0px",width:"27px",right:"0px",bottom:"0px"}}> 
      <div className="ElementSettingsItem" style={{position:"relative",left:"-1px"}} 
      onMouseEnter={
                        ()=>handleMouseEnter("rgba(144, 202, 249,1) "," #ffffff","Delete element")}
        onMouseLeave={handleMouseLeave}
         onClick={()=>{deleteItem(item)}}
        >
      <Trash2 size={18}  color="#444" />
      </div>
      </div></div> </>:""}</div>}
     
      
        {
      extractElementType(item?.myKey)=="list1"?  <ListUI
     setCurrentContentIndex={(currentContentIndex)=>{setCurrentContentIndex(currentContentIndex);
      // alert(currentContentIndex)
    }}
        CurrentObject ={item} 
       currentIndex={currentIndex} dynamicId={dynamicId} 
             setCurrentObject={(currentItemKey,currentItem)=>{setCurrentObject(currentItemKey,currentItem);
              // alert(parseInt(currentItem?.contentNo)+currentItem?.myKey)
            }}
           
          moveItemUp={(item)=>{moveItemUp(item);setHideReduUnDo(true)}} moveItemDown={(item)=>{moveItemDown(item);setHideReduUnDo(true)}} 
      deleteItem={(item)=>{deleteItem(item);setHideReduUnDo(true)}}  duplicateContentsItem={(item)=>{duplicateContentsItem(item)}}  duplicateItem={(item)=>{duplicateItem(item);setHideReduUnDo(true)}} 
      
      item={item}
           
           

   />
     :""}
      {
      <>  
     
      <PlatformKeyFeaturesCardIndexPage
     setCurrentContentIndex={(currentContentIndex)=>{setCurrentContentIndex(currentContentIndex);
      // alert(currentContentIndex)
    }}
        CurrentObject ={item} 
       currentIndex={currentIndex} dynamicId={dynamicId} 
             setCurrentObject={(currentItemKey,currentItem)=>{setCurrentObject(currentItemKey,currentItem);
              // alert(parseInt(currentItem?.contentNo)+currentItem?.myKey)
            }}
           
          moveItemUp={(item)=>{moveItemUp(item);setHideReduUnDo(true)}} moveItemDown={(item)=>{moveItemDown(item);setHideReduUnDo(true)}} 
      deleteItem={(item)=>{deleteItem(item);setHideReduUnDo(true)}}  duplicateContentsItem={(item)=>{duplicateContentsItem(item)}}  duplicateItem={(item)=>{duplicateItem(item);setHideReduUnDo(true)}} 
      
      item={item}
           
           

   />
   <Theme1CardsIndexPage
     setCurrentContentIndex={(currentContentIndex)=>{setCurrentContentIndex(currentContentIndex);
      // alert(currentContentIndex)
    }}
        CurrentObject ={item} 
       currentIndex={currentIndex} dynamicId={dynamicId} 
             setCurrentObject={(currentItemKey,currentItem)=>{setCurrentObject(currentItemKey,currentItem);
              
              // alert(parseInt(currentItem?.contentNo)+currentItem?.myKey)
            }}
           
          moveItemUp={(item)=>{moveItemUp(item);scrollToSection()}} moveItemDown={(item)=>{moveItemDown(item);scrollToSectionDown()}} 
      deleteItem={(item)=>{deleteItem(item);}}  duplicateContentsItem={(item)=>{duplicateContentsItem(item);

      }}  duplicateItem={(item)=>{duplicateItem(item);scrollToSectionDown() }} 
      
      item={item}
           
           

   />
   
    
      </> 
    }
      {
      extractElementType(item?.myKey)=="PlayerPageCard1"? <>  
     
      <PlayerPageCard1
     setCurrentContentIndex={(currentContentIndex)=>{setCurrentContentIndex(currentContentIndex);
      // alert(currentContentIndex)
    }}
        CurrentObject ={item} 
       currentIndex={currentIndex} dynamicId={dynamicId} 
             setCurrentObject={(currentItemKey,currentItem)=>{setCurrentObject(currentItemKey,currentItem);
              // alert(parseInt(currentItem?.contentNo)+currentItem?.myKey)
            }}
           
          moveItemUp={(item)=>{moveItemUp(item);setHideReduUnDo(true)}} moveItemDown={(item)=>{moveItemDown(item);setHideReduUnDo(true)}} 
      deleteItem={(item)=>{deleteItem(item);setHideReduUnDo(true)}}  duplicateContentsItem={(item)=>{duplicateContentsItem(item)}}  duplicateItem={(item)=>{duplicateItem(item);setHideReduUnDo(true)}} 
      
      item={item}
           
           

   /></> 
     :""}
   
     {
       extractElementType(item?.myKey)=="list2"?  
       <ListUI 
       CurrentObject ={item} 
       currentIndex={currentIndex} dynamicId={item?.myKey} 
            setCurrentObject={()=>{setCurrentObject(item?.myKey,item);}}
          moveItemUp={(item)=>{moveItemUp(item);setHideReduUnDo(true)}} moveItemDown={(item)=>{moveItemDown(item);setHideReduUnDo(true)}} 
      deleteItem={(item)=>{deleteItem(item);setHideReduUnDo(true)}}  duplicateContentsItem={(item)=>{duplicateContentsItem(item);setHideReduUnDo(true)}}  duplicateItem={(item)=>{duplicateItem(item);setHideReduUnDo(true)}} 
      
      item={item}
           
     />
     :""}
     {isHovered? <div className={isHovered?"showPlusElementOuter":"" } > <div className="showPlusElement"  onMouseEnter={
                        ()=>handleMouseEnter("","","")}
        onMouseLeave={handleMouseLeave} style={{}}><div style={{padding:"5px",marginBottom:"-19px",width:"25px",height:"25px",borderRadius:"50%",background:"rgba(144, 202, 249,0.41)"}} ><Plus size={23} style={{width:"25px",height:"25px",borderRadius:"50%",background:"rgba(144, 202, 249,0.941)"}} color="#ffffff" /></div></div></div>
   :""}
    </div>
  </div> );
};


export default UIWebBlockRenderer;
